import { SxProps, Theme } from '@mui/system';

const styles = {
  tableContainer: { maxHeight: '456px', overflow: 'auto' },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '24px',
    border: '1px solid',
    borderColor: 'common.border',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
